/* eslint-disable no-unused-vars */
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import errorData                 from './errors-dux';
import successData               from './success-dux';
import clientData                from './client-dux';
import catalogData               from './catalog-dux';
import userData, { USER_LOGOUT } from './user-dux';
import activationData            from './components/routes/activation/activation-dux';
import loginData                 from './components/routes/login/login-dux';
import profileData               from './components/routes/profile/profile-dux';
import forgotUserIdData          from './components/routes/forgot-user-id/forgot-user-id-dux';
import forgotPasswordData        from './components/routes/forgot-password/forgot-password-dux';
import resetPasswordData         from './components/routes/reset-password/reset-password-dux';
import rulesData                 from './components/routes/rules/rules-dux';
import contactUsData             from './components/routes/contact/contact-dux';
import activityHistoryData       from './components/routes/activity-history/activity-history-dux';
import onTheSpotData             from './components/shared/on-the-spot/on-the-spot-dux';
import ssoAuthenticated          from './components/routes/sso-authenticated/sso-authenticated-dux';

/*******************************************************************************
 *  Gather all the reducers
 */

const AppStore = () => {
    const appReducer = combineReducers( {
        errorData,
        clientData,
        activationData,
        userData,
        loginData,
        profileData,
        forgotUserIdData,
        forgotPasswordData,
        resetPasswordData,
        contactUsData,
        activityHistoryData,
        rulesData,
        successData,
        catalogData,
        onTheSpotData,
        ssoAuthenticated
    } );

    const rootReducer = ( state, action ) => {
        if ( action.type === USER_LOGOUT ) {
            const { clientData, ssoAuthenticated } = state;
            state = {
                clientData,
                userData: {
                    authenticated: false,
                    locale: clientData.locale
                },
                ssoAuthenticated
            };
        }
        return appReducer( state, action );
    };

    /*******************************************************************************
     *  Create Store
     */
    const middleware = [ thunk ];

    if ( window.location.port === '5000' ) {
        middleware.push( createLogger( {
            collapsed: true
        } ) );
    }

    return createStore(
        rootReducer,
        compose( applyMiddleware.apply( null, middleware ) )
    );
};

export default AppStore;
